import React from 'react';
import { LeadForm } from '../components/site/LeadForm';
import { contactFields } from '../components/site/leadFormConfigs';
import { PageRenderer } from '../components/site/PageRenderer';
import { Seo } from '../components/site/Seo';
import { useSiteContent } from '../context/SiteContentContext';

export function ContactPage() {
  const { siteContent } = useSiteContent();
  const page = siteContent.pages.contact;

  return (
    <>
      <Seo page={page} />
      <PageRenderer page={page} />
      <section className='content-section cta-form-section contact-section'>
        <LeadForm
          formName='contact'
          title='Contact form'
          intro='Share the essentials so the right person can reply quickly.'
          fields={contactFields}
          submitLabel='Send message'
        />
      </section>
    </>
  );
}
